import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export interface IProps {
  icon: FontAwesomeIconProps['icon'];
  title?: string;
  variant?: 'primary' | 'danger';
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  loading?: boolean;
  iconProps?: Omit<FontAwesomeIconProps, 'icon'>
}

const IconButton = forwardRef<HTMLButtonElement, IProps>((props, ref) => {
  const { title, icon, iconProps, onClick, disabled, className, variant = 'primary', loading } = props;

  return (
    <button
      ref={ref}
      title={title}
      onClick={onClick}
      disabled={disabled}
      className={classNames('btn', 'icon-button', variant, className)}>
      <span>
        {
          loading ?
            <FontAwesomeIcon icon={faSpinner} {...{ ...iconProps, spin: true }} />
            : <FontAwesomeIcon icon={icon} {...iconProps} />
        }
      </span>
    </button>)
});

IconButton.displayName = 'IconButton';

export default IconButton;
